import Dexie from 'dexie';

const db = new Dexie('CompanyCoreDB');

db.version(2).stores({
  // Pending data to sync when online
  pendingPunches: '++id, employee_id, type, punched_at',
  pendingCheckpoints: '++id, trip_id, type, captured_at',
  pendingClaims: '++id, employee_id, status, created_at',
  pendingLeave: '++id, employee_id, leave_type_code, start_date',

  // Cached data for fast offline reads
  cachedAttendance: '[employee_id+punch_date], punch_date',
  cachedTrips: 'id, driver_id, status, started_at',
  cachedClaims: 'id, employee_id, status, created_at',
  cachedLeaveBalances: 'employee_id',
});

export default db;
